import { useNavigate } from "react-router-dom";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import ReplyIcon from "@mui/icons-material/Reply";
import AddReply from "../../Modals/addReply";
import AddRatingReply from "../../Modals/ratingreply";

const Ratings = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const [rows] = useState([
        {
            id: 1,
            name: "Alice Johnson",
            email: "alice.johnson@example.com",
            phone: "+91 9876543210",
            orderId: "#BOOK_001",
            productId: "#PRD_001",
            rating: 5,
            review: "Excellent product, fast delivery!",
            date: "20 Oct 2025",
        },
        {
            id: 2,
            name: "Bob Smith",
            email: "bob.smith@example.com",
            phone: "+91 9123456789",
            orderId: "#BOOK_002",
            productId: "#PRD_003",
            rating: 4,
            review: "Good quality but packaging could be better.",
            date: "18 Oct 2025",
        },
        {
            id: 3,
            name: "Carol Williams",
            email: "carol.williams@example.com",
            phone: "+91 9988776655",
            orderId: "#BOOK_003",
            productId: "#PRD_007",
            rating: 3,
            review: "Average experience. Expected faster delivery.",
            date: "16 Oct 2025",
        },
    ]);

    const columns = [
        { id: "srNo", label: "Sr. No." },
        { id: "userDetails", label: "Vendor Details" },
        { id: "orderId", label: "Booking ID" },
        { id: "rating", label: "Rating" },
        { id: "review", label: "Review" },
        { id: "date", label: "Date" },
        { id: "action", label: "Action" },
    ];

    return (
        <>
            <div className="main_title">
                <h1>Manage Ratings & Reviews</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Ratings & Reviews
                </p>
            </div>

            <div className="cards">
                {/* Table Header */}
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search by user, product, or order..."
                            />
                        </Box>
                    </div>
                </div>

                {/* Table */}
                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow hover>
                                {columns.map((column) => (
                                    <TableCell key={column.id}>{column.label}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow hover key={row.id}>
                                    <TableCell>{index + 1}</TableCell>

                                    {/* User Details */}
                                    <TableCell>
                                        <a
                                            href="/manage-customers/details"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate("/manage-customers/details");
                                            }}
                                            className="user_block click_action"
                                        >
                                            <figure>
                                                <img
                                                    src="/static/images/user_placeholder.png"
                                                    alt="User"
                                                />
                                            </figure>
                                            <p>
                                                <b>{row.name}</b>
                                                {row.email}
                                                <br />
                                                {row.phone}
                                            </p>
                                        </a>
                                    </TableCell>

                                    <TableCell>{row.orderId}</TableCell>

                                    {/* Rating */}
                                    <TableCell>
                                        {"⭐".repeat(row.rating)}
                                        {row.rating < 5 ? "☆".repeat(5 - row.rating) : ""}
                                    </TableCell>
                                    <TableCell className="max_c2">{row.review}</TableCell>
                                    <TableCell>{row.date}</TableCell>
                                    {/* Actions */}
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => setOpenModal(true)}>
                                                    <ReplyIcon />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton>
                                                    <img
                                                        src="/static/images/trash2_icon.svg"
                                                        alt="Delete"
                                                    />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {rows.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No records found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {/* ✅ Pass all required props */}
            <AddRatingReply
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default Ratings;
